export enum CoreConfigPermissionsMask {
  READ = 0,
  WRITE = 1 << 0,
  OTHER = 1 << 1,
}

export enum CoreConfigPermissionSimpleMask {
  DISALLOWED = 0,
  ALLOWED = 1 << 0,
}